import React from "react";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";

export default function SaveFailedModal() {
  const { closeModal } = useModal();

  return (
    <div className="text-center">
      <ModalTitle>Save failed</ModalTitle>
      <Module>
        <p>
          Sorry, something went wrong and your animation was not saved. Please
          try again.
        </p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button onClick={closeModal} type="positive" rightAlign>
            <FontAwesomeIcon icon={faCheckCircle} /> Ok
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
